export default [
    {
        path: '/chats',
        name: 'chat',
        meta: { requiresAuth: true },
        component: () => import('@/pages/chat/index.vue')
    }
]
